/* eslint-disable jsx-a11y/anchor-has-content */
import * as React from 'react';
import Disclaimer from './disclaimer';

import '../../styles/App.css';

export default function Footer() {
  return (
    <div className="footer">
      <div className="content boxSize">
        <div className="grids">
          <ul className="list">
            <li className="item">
              <a
                href="//www.vodafone.de/unternehmen/auszeichnungen.html"
                className="item-in-list"
              ></a>
            </li>
            <li className="item">
              <a
                href="//www.vodafone.de/unternehmen/auszeichnungen.html"
                className="item-in-list item2"
              ></a>
            </li>
            <li className="item">
              <a
                href="//www.vodafone.de/unternehmen/auszeichnungen.html"
                className="item-in-list item3"
              ></a>
            </li>
            <li className="item">
              <a
                href="//www.vodafone.de/unternehmen/auszeichnungen.html"
                className="item-in-list item4"
              ></a>
            </li>
          </ul>
        </div>
      </div>
      <div className="content boxSize">
        <div className="copyright">
          <span>© 2021 Vodafone GmbH</span>
        </div>
      </div>
      <Disclaimer/>
    </div>
  )
}